<div class="m-4">
    <h1>Bienvenido al home</h1>
    <div style="height: 300px">
        <p>Este es un texto</p>
    </div>
</div>
